// session/UserSessionModel.js

export function createUserSession({
  account,
  accessToken,
  idToken,
  expirationTime,
  loginTime,
  idTokenClaims,
  userData,
}) {
  return {
    auth: {
      accessToken,
      idToken: idToken || "",
      tokenExpiration: expirationTime || null,
      loginTime: loginTime || Date.now(),
      accountId: account?.homeAccountId || account?.localAccountId || account?.id || null,
    },
    user: {
      id: userData?.id ?? null,
      email: userData?.email || account?.username || idTokenClaims?.email || idTokenClaims?.emails?.[0] || null,
      firstName: userData?.first_name || null,
      lastName: userData?.last_name || null,
      fullName: `${userData?.first_name ?? ""} ${userData?.last_name ?? ""}`.trim() || account?.name || null,
      phone: userData?.phone || null,
      role: userData?.role || null,
      jobTitle: idTokenClaims?.jobTitle || account?.idTokenClaims?.jobTitle || null,
      isActive: userData?.is_active ?? null,
    },
    organization: {
      id: userData?.organization_id ?? null,
      name: userData?.organization_name || null,
    },


  };
}



//   tokenExpiration: account.idTokenClaims?.exp * 1000,
//   loginTime: Date.now(),
//   idToken: account.idToken